package org.zest.insan_360_website.utils
import org.zest.insan_360_website.data.localized

import kotlinx.browser.window
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.await
import kotlinx.coroutines.launch
import kotlinx.serialization.json.Json
import org.zest.insan_360_website.components.widgets.ModalState
import org.zest.insan_360_website.components.widgets.ToastState
import org.zest.insan_360_website.components.widgets.ToastType
import org.zest.insan_360_website.data.LanguageSettings
import org.zest.insan_360_website.data.page_states.AuthState
import org.zest.insan_360_website.data.page_states.UserPreferences
import org.zest.insan_360_website.model.*

val paymentModalLocalized = LanguageSettings.UserDashboardPage.PaymentModal

fun buyCredit(
    toast: ToastState,
    modal: ModalState,
    scope: CoroutineScope,
    amount: Int = 1,
    onProcessingChange: (Boolean) -> Unit
) {
    val email = AuthState.email
    val token = AuthState.token
    val role = AuthState.role
    val orgId = AuthState.orgId
    val isNotSupAdm = role != UserRole.SUPER_ADMIN

    if (!isNotSupAdm) {
        toast.show(
            paymentModalLocalized.super_not_required.localized
        )
        return
    }
    if (email == null) {
        toast.show(
            paymentModalLocalized.email_not_found.localized,
            ToastType.ERROR
        )
        return
    }
    if (token == null) {
        toast.show(
            paymentModalLocalized.token_not_found.localized,
            ToastType.ERROR
        )
        return
    }

    onProcessingChange(true)

    scope.launch {
        try {
            val response =
                if (role == UserRole.ADMIN) {
                    val request = AdminRequest(email, role, BuyCreditRequest(email, amount))
                    NetworkUtils.postSecureApi("/api/payment/buy-bulk-credit-fpx", request)
                } else {
                    if (orgId == null) NetworkUtils.postSecureApi("/api/payment/buy-single-credit-fpx")
                    else throw Exception(
                        paymentModalLocalized.already_under_org.localized
                    )
                }

            if (response == null) throw Exception(
                LanguageSettings.ResponseError.session_expired.localized
            )

            val responseText = response.text().await()

            if (response.ok) {
                val result = Json.decodeFromString<GenericPaymentResponse>(responseText)

                if (result.success && result.redirectUrl.isNotBlank()) {
                    window.location.assign(result.redirectUrl)
                } else {
                    toast.show(
                        paymentModalLocalized.initiation_failed.localized,
                        ToastType.ERROR
                    )
                    onProcessingChange(false)
                }
            } else {
                val result = Json.decodeFromString<GenericResponse>(responseText)
                val errorMessage = result.errorCode?.let {
                    LanguageSettings.ApiErrors.getMessage(it, UserPreferences.language)
                } ?: result.debugMessage ?: paymentModalLocalized.initiation_failed.localized
                toast.show(errorMessage, ToastType.ERROR)
                console.log(result.toString())
                onProcessingChange(false)
                modal.hide()
            }
        } catch (e: Exception) {
            toast.show(
                LanguageSettings.General.networkFailure.localized,
                ToastType.ERROR
            )
            onProcessingChange(false)
            modal.hide()
        }
    }
}